import { GenericNoSubHeaderPage, GenericPage } from "../../../../../pages";

import { branchRoute } from "./stockify-branch.route";
import { catalogueRoutes } from "./stockify-catalogue.route";
import { clientRoute } from "./stockify-client.route";
import { historyRoute } from "./stockify-history.route";
import { importRoutes } from "./stockify-imports.route";
import { inventoryRoute } from "./stockify-inventory.route";
import { ordersRoute } from "./stockify-orders.route";
import { quotationRoutes } from "./stockify-quotation.route";
import { recurrenceRoutes } from "./stockify-recurrence.route";
import { stkSaleRoutes } from "./stockify-sale.route";
import { supplierRoute } from "./stockify-supplier.route";

export const stockifyRoutes = [
  {
    path: "branches",
    element: <GenericPage />,
    children: branchRoute,
  },
  {
    path: "catalogues",
    element: <GenericPage />,
    children: catalogueRoutes,
  },
  {
    path: "clients",
    element: <GenericPage />,
    children: clientRoute,
  },
  {
    path: "history",
    element: <GenericNoSubHeaderPage />,
    children: historyRoute,
  },
  {
    path: "inventory",
    element: <GenericPage />,
    children: inventoryRoute,
  },
  {
    path:"import",
    element: <GenericPage />,
    children: importRoutes,
  },
  {
    path: "orders",
    element: <GenericPage />,
    children: ordersRoute,
  },
  {
    path: "quotation",
    element: <GenericPage />,
    children: quotationRoutes,
  },
  {
    path: "recurrence",
    element: <GenericPage />,
    children: recurrenceRoutes,
  },
  {
    path: "sales",
    element: <GenericPage />,
    children: stkSaleRoutes,
  },
  {
    path: "suppliers",
    element: <GenericPage />,
    children: supplierRoute,
  },
];
